export default "79fd2e20f8798683.woff2"